import { Alert, Button, Snackbar } from '@mui/material';
import React, { useEffect } from 'react';

import { useStaleBundleDetection } from './useStaleBundleDetection';

const AUTO_RELOAD_MS = 5_000;

function hasUnsavedInput(): boolean {
  return Array.from(document.querySelectorAll('input, textarea')).some(
    (el) => (el as HTMLInputElement | HTMLTextAreaElement).value !== '',
  );
}

export function StaleBundleBanner() {
  const { detected } = useStaleBundleDetection();

  useEffect(() => {
    if (!detected) return;
    const timer = setTimeout(() => {
      if (!hasUnsavedInput()) window.location.reload();
    }, AUTO_RELOAD_MS);
    return () => clearTimeout(timer);
  }, [detected]);

  return (
    <Snackbar open={detected} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
      <Alert
        severity="warning"
        action={
          <Button color="inherit" size="small" onClick={() => window.location.reload()}>
            Reload
          </Button>
        }
      >
        New version available — reload to continue.
      </Alert>
    </Snackbar>
  );
}
